// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalContent--xJ8Ui4Lp{display:flex;height:calc(100vh - 200px);min-height:500px;max-height:700px;margin:-16px -20px;gap:0;overflow:hidden;border-bottom:1px solid rgba(0,0,0,0.06)}.aiAssistantArea--S13sfbOF{flex:1 0 360px;max-width:550px;display:flex;flex-direction:column;border-right:1px solid rgba(0,0,0,0.1);border-radius:0 0 0 16px;padding:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `modalContent--xJ8Ui4Lp`,
	"aiAssistantArea": `aiAssistantArea--S13sfbOF`
};
export default ___CSS_LOADER_EXPORT___;
